import React, { useEffect, useMemo } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

const DEFAULT_CENTER = { lat: -33.4489, lng: -70.6693 }; // Santiago, CL (fallback)

const normalizeLatLng = (value) => {
  if (!value) return null;
  const lat = Number(value.lat);
  const lng = Number(value.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return { lat, lng };
};

const ClickToSetMarker = ({ disabled, value, onChange }) => {
  useMapEvents({
    click: (event) => {
      if (disabled) return;
      onChange?.({ lat: event.latlng.lat, lng: event.latlng.lng });
    }
  });
  return value ? (
    <Marker
      position={[value.lat, value.lng]}
      draggable={!disabled}
      eventHandlers={{
        dragend: (event) => {
          if (disabled) return;
          const next = event?.target?.getLatLng?.();
          if (!next) return;
          onChange?.({ lat: next.lat, lng: next.lng });
        }
      }}
    />
  ) : null;
};

const CoordinatePickerMap = ({
  value,
  onChange,
  disabled = false,
  heightClassName = 'h-72',
  zoom = 9
}) => {
  const normalized = useMemo(() => normalizeLatLng(value), [value]);
  const center = normalized || DEFAULT_CENTER;

  useEffect(() => {
    // Fix Leaflet default icon paths under CRA bundling.
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: markerIcon2x,
      iconUrl: markerIcon,
      shadowUrl: markerShadow
    });
  }, []);

  return (
    <div className={`rounded overflow-hidden border border-neutral-200 ${heightClassName}`}>
      <MapContainer
        center={[center.lat, center.lng]}
        zoom={zoom}
        scrollWheelZoom
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <ClickToSetMarker disabled={disabled} value={normalized} onChange={onChange} />
      </MapContainer>
    </div>
  );
};

export default CoordinatePickerMap;

